/*
 * Dolgum — welcome popup for new visitors (not exit-intent).
 * Shows once per browser, a few seconds after page load, offering a real
 * 10% discount code (DOLGUM10) — no strings attached, works immediately at
 * checkout whether or not the visitor joins the mailing list.
 *
 * IMPORTANT DESIGN NOTE: Shopify's native customer-signup endpoint
 * (/contact, the same one Dawn's footer newsletter form posts to) requires
 * a bot-detection token that is only generated by a genuine, real user
 * interacting with the actual rendered form — it cannot be attached by a
 * script submitting on the visitor's behalf (fetch, form.submit(), or a
 * scripted .click()), and this code intentionally does not attempt any of
 * those workarounds. Instead, if the visitor also wants to join the list,
 * this script pre-fills the real footer signup form with their email and
 * scrolls it into view so THEY complete the actual subscribe click
 * themselves — a real, un-scripted interaction — which is the only way to
 * make the signup legitimate and reliable.
 *
 * Skips checkout-ish pages, and skips itself if the exit-intent popup
 * (erdensai-cro-boost.js) already showed or converted this session, to
 * avoid popup fatigue.
 * Additive/non-destructive: only ever appends new elements, and only ever
 * fills in the real footer form's own email field — never submits it.
 */
(function () {
  var CODE = 'DOLGUM10';
  var ACCENT = 'rgb(var(--color-button))';
  var ACCENT_TEXT = 'rgb(var(--color-button-text))';
  var isCheckoutish = /\/(cart|checkout|account|policies)\b/.test(window.location.pathname);

  if (isCheckoutish) return;

  try {
    if (localStorage.getItem('eaiWelcomePopupShown') === '1') return;
    if (localStorage.getItem('eaiExitConverted') === '1') return;
    if (sessionStorage.getItem('eaiExitShown') === '1') return;
  } catch (e) {}

  function injectStyle(css) {
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);
  }

  injectStyle(
    '.eai5-overlay{position:fixed;inset:0;background:rgba(0,0,0,.5);z-index:9998;' +
    'display:flex;align-items:center;justify-content:center;padding:1rem;' +
    'opacity:0;transition:opacity .25s ease;}' +
    '.eai5-overlay.eai5-show{opacity:1;}' +
    '.eai5-modal{background:#fff;border-radius:16px;max-width:400px;width:100%;' +
    'padding:2rem 1.75rem;text-align:center;font-family:var(--font-body-family);' +
    'position:relative;transform:scale(.94);transition:transform .25s ease;}' +
    '.eai5-overlay.eai5-show .eai5-modal{transform:scale(1);}' +
    '.eai5-modal__close{position:absolute;top:.6rem;right:.9rem;background:none;border:none;' +
    'font-size:1.4rem;cursor:pointer;color:#9ca3af;line-height:1;}' +
    '.eai5-modal__title{font-family:var(--font-heading-family);font-size:1.5rem;font-weight:700;' +
    'color:#1f2937;margin:0 0 .5rem;}' +
    '.eai5-modal__sub{font-size:.98rem;color:#6b7280;margin:0 0 1.3rem;}' +
    '.eai5-modal__input{width:100%;padding:.85rem 1rem;border:1.5px solid #d1d5db;border-radius:9px;' +
    'font-size:1rem;margin-bottom:.7rem;box-sizing:border-box;}' +
    '.eai5-modal__btn{width:100%;padding:.9rem 1rem;border:none;border-radius:9px;' +
    'background:' + ACCENT + ';color:' + ACCENT_TEXT + ';font-size:1.05rem;font-weight:700;cursor:pointer;}' +
    '.eai5-modal__skip{display:block;margin-top:.9rem;font-size:.85rem;color:#9ca3af;' +
    'text-decoration:underline;cursor:pointer;background:none;border:none;}' +
    '.eai5-modal__code{font-family:var(--font-heading-family);font-size:1.6rem;font-weight:800;' +
    'letter-spacing:.1em;color:' + ACCENT + ';border:2px dashed ' + ACCENT + ';border-radius:9px;' +
    'padding:.7rem 1rem;margin:0 0 1rem;}' +
    '.eai5-modal__copy{width:100%;padding:.8rem 1rem;border:none;border-radius:9px;' +
    'background:' + ACCENT + ';color:' + ACCENT_TEXT + ';font-size:.98rem;font-weight:700;cursor:pointer;' +
    'margin-bottom:.6rem;}' +
    '.eai5-modal__join{width:100%;padding:.8rem 1rem;border:1.5px solid #d1d5db;border-radius:9px;' +
    'background:#fff;color:#374151;font-size:.92rem;font-weight:600;cursor:pointer;}' +
    '@keyframes eai5-pulse{0%,100%{box-shadow:0 0 0 0 rgba(0,0,0,.15);}50%{box-shadow:0 0 0 6px rgba(0,0,0,0);}}' +
    '.eai5-highlight{animation:eai5-pulse 1.1s ease-in-out 2;border-radius:9px;}'
  );

  function markShown() {
    try { localStorage.setItem('eaiWelcomePopupShown', '1'); } catch (e) {}
  }

  // Pre-fills the REAL footer newsletter form with the visitor's email so
  // that if they choose to confirm, it's a genuine one-click action on
  // Shopify's own form — never submitted by this script.
  function prefillRealForm(email) {
    var form = document.getElementById('ContactFooter');
    if (!form) return null;
    var input = form.querySelector('input[name="contact[email]"]');
    if (!input) return null;
    input.value = email;
    return form;
  }

  function scrollToRealFormAndHighlight(form) {
    form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var btn = form.querySelector('button[type="submit"], input[type="submit"]');
    var target = btn || form;
    target.classList.add('eai5-highlight');
    setTimeout(function () { target.classList.remove('eai5-highlight'); }, 2400);
  }

  function showCodeStep(modal, email) {
    modal.innerHTML =
      '<p class="eai5-modal__title">You\'re In! 🎉</p>' +
      '<p class="eai5-modal__sub">Here\'s your 10% off code — it\'s already valid, use it any time at checkout.</p>' +
      '<div class="eai5-modal__code">' + CODE + '</div>' +
      '<button type="button" class="eai5-modal__copy">Copy Code</button>' +
      '<button type="button" class="eai5-modal__join">Also join our mailing list →</button>';

    var copyBtn = modal.querySelector('.eai5-modal__copy');
    copyBtn.addEventListener('click', function () {
      var done = function () {
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy Code'; }, 1800);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(CODE).then(done).catch(done);
      } else {
        done();
      }
    });

    var joinBtn = modal.querySelector('.eai5-modal__join');
    joinBtn.addEventListener('click', function () {
      var form = prefillRealForm(email);
      var overlay = modal.closest('.eai5-overlay');
      if (overlay) {
        overlay.classList.remove('eai5-show');
        setTimeout(function () { overlay.remove(); }, 250);
      }
      if (form) {
        setTimeout(function () { scrollToRealFormAndHighlight(form); }, 300);
      }
    });
  }

  function buildModal() {
    var overlay = document.createElement('div');
    overlay.className = 'eai5-overlay';
    overlay.innerHTML =
      '<div class="eai5-modal">' +
        '<button type="button" class="eai5-modal__close" aria-label="Close">&times;</button>' +
        '<p class="eai5-modal__title">Get 10% Off 🐾</p>' +
        '<p class="eai5-modal__sub">Enter your email for an instant 10% off code — no purchase or signup required to use it.</p>' +
        '<input type="email" class="eai5-modal__input" placeholder="you@example.com" required>' +
        '<button type="button" class="eai5-modal__btn">Get My Code</button>' +
        '<button type="button" class="eai5-modal__skip">No thanks</button>' +
      '</div>';

    function close() {
      overlay.classList.remove('eai5-show');
      setTimeout(function () { overlay.remove(); }, 250);
    }

    overlay.querySelector('.eai5-modal__close').addEventListener('click', close);
    overlay.querySelector('.eai5-modal__skip').addEventListener('click', close);
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    var btn = overlay.querySelector('.eai5-modal__btn');
    var input = overlay.querySelector('.eai5-modal__input');
    btn.addEventListener('click', function () {
      var email = input.value.trim();
      if (!email || email.indexOf('@') === -1) {
        input.style.borderColor = '#dc2626';
        return;
      }
      showCodeStep(overlay.querySelector('.eai5-modal'), email);
    });

    document.body.appendChild(overlay);
    markShown();
    requestAnimationFrame(function () {
      overlay.classList.add('eai5-show');
    });
  }

  setTimeout(buildModal, 6000);
})();
